import React, { useState } from "react";
import { allDocTypes } from "./saveInvoiceData";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import classes from "./ObjectPlaygroundComponents.module.scss";

const Docs = ({ onPassDocs }) => {
  const [checkedDocs, setCheckedDocs] = useState([]);

  const onDocsClickHandler = (e) => {
    const checkedValue = e.target.value;
    let newCheckedDocs = [...checkedDocs];

    if (e.target.checked) {
      newCheckedDocs.push(checkedValue);
    } else {
      newCheckedDocs = newCheckedDocs.filter((value) => value !== checkedValue);
    }

    newCheckedDocs.sort((a, b) => a - b);
    setCheckedDocs(newCheckedDocs);
    onPassDocs(newCheckedDocs);
  };

  return (
    <>
      <span className={classes["span-label"]}>Choose return docs:</span>
      <div className={`${classes["doc-field"]} my-3`}>
        {allDocTypes.map((docType, index) => {
          const tooltip = (
            <Tooltip id={`tooltip-${index}`}>{docType.description}</Tooltip>
          );

          return (
            <OverlayTrigger
              placement="bottom"
              overlay={tooltip}
              key={`overlay-trigger-${index}`}
            >
              <div className={classes["steps-container"]}>
                <input
                  key={`doc-field-${index}`}
                  type="checkbox"
                  id={`doc-field-${index}`}
                  className={classes["doc-field__input"]}
                  value={docType.doc}
                  onChange={onDocsClickHandler}
                />
                <label
                  htmlFor={`doc-field-${index}`}
                  className={classes["doc-field__label"]}
                >
                  {docType.doc}
                </label>
              </div>
            </OverlayTrigger>
          );
        })}
      </div>
    </>
  );
};

export default Docs;
